// extracted by mini-css-extract-plugin
module.exports = {"card":"CardIcon_card__xa_NA","card-hasBorder":"CardIcon_card-hasBorder__sAcIw","card-inactive":"CardIcon_card-inactive__xFh33"};